import { getResourceType, pluralizeResourceType } from '../../../utils';

import type { ILesson } from '../../../graphql/types';

export const helpers = ({ path = '', lesson }: { path: string; lesson: ILesson; }) => {
  const isCollectionLesson = Boolean(
    path.includes('/collections') && lesson?.course?.collections.length && lesson?.course?.collections[0].slug,
  );

  const iframeSrc = isCollectionLesson
    ? `${import.meta.env.PUBLIC_IFRAME_SOURCE}/path/${lesson?.course?.collections[0].slug}/${lesson?.course?.slug}/${lesson?.pathId}`
    : `${import.meta.env.PUBLIC_IFRAME_SOURCE}/${lesson?.course?.slug}/${lesson?.pathId}`;

  const courseUrl = isCollectionLesson
    ? `/en-us/collections/${lesson?.course?.collections[0].slug}/${lesson?.course?.slug}`
    : `/en-us/courses/${lesson?.course?.slug}`;

  const collectionUrl = isCollectionLesson ? `/en-us/collections/${lesson?.course?.collections[0].slug}` : '';


  const isSingleLessonCourse = Array.isArray(lesson?.course?.lessons) ? lesson?.course.lessons.length === 1 : false;
  const resourceType = getResourceType(lesson?.course?.tags);
  const pluralizedResourceType = pluralizeResourceType(resourceType);

  return {
    isCollectionLesson,
    iframeSrc,
    courseUrl,
    collectionUrl,
    isSingleLessonCourse,
    resourceType,
    pluralizedResourceType,
  };
};
